const eventLabels = {
  DRAFT: 'Rascunho',
  PUBLISHED: 'Publicado',
  CANCELLED: 'Cancelado',
  FINISHED: 'Finalizado',
};

const enrollmentLabels = {
  PAYMENT_PENDING: 'Aguardando pagamento',
  PARTIALLY_PAID: 'Parcialmente paga',
  AWAITING_DECISION: 'Aguardando decisão da escola',
  CONFIRMED: 'Confirmada',
  CANCELLED: 'Cancelada',
  EXPIRED: 'Expirada',
  REFUND_PENDING: 'Reembolso pendente',
  REFUNDED: 'Reembolsada',
};

const paymentLabels = {
  PENDING: 'Pendente',
  APPROVED: 'Aprovado',
  FAILED: 'Falhou',
  RECEIVED: 'Recebido',
  PROCESSED: 'Processado',
  REFUNDED: 'Reembolsado',
};

const label = (labels, value) => labels[value] || value || '—';
export const eventStatusLabel = (value) => label(eventLabels, value);
export const enrollmentStatusLabel = (value) => label(enrollmentLabels, value);
export const paymentStatusLabel = (value) => label(paymentLabels, value);
